import "./style/index.scss";
import { ConfigProvider, Steps } from "antd";
import { useAppSelector } from "../../../../util/hooks";
import { StatusResultadoSorteioModel } from "../../../../models/resultadoSorteio/statusResultadoSorteioModel";

const StepsResultado = (props: any) => {
  //estados globais
  const resultadoSorteioState = useAppSelector((state) => state.resultadoSorteio);

  return (
    <ConfigProvider
      theme={{
        components: {
          Steps: {
            colorPrimary: "#334155",
            // finishIconBorderColor: "#334155",
          },
        },
        token: {
          // Seed Token
          colorPrimary: "#334155",
          borderRadius: 1,

          // Alias Token
          colorBgContainer: "#f6ffed",
        },
      }}
    >
      <Steps
        direction="vertical"
        size="default"
        percent={60}
        className="steps"
        current={props.ordem}
        items={resultadoSorteioState.statusResultadoSorteio
          .concat({ codigo: "NADA", id: 0, ordem: 0, denominacao: "Resultado não calculado", descricao: "Aguardando calculo do resultado pelo financeiro da base" })
          .sort((a: any, b: any) => a.ordem - b.ordem)
          .map((a: StatusResultadoSorteioModel) => ({
            title: a.denominacao,
            description: a.descricao,
            status: a.ordem === props.ordem ? (a.ordem === resultadoSorteioState.statusResultadoSorteio.length ? "finish" : "process") : a.ordem < props.ordem ? "finish" : "wait",
          }))}
      />
    </ConfigProvider>
  );
};

export default StepsResultado;
